import { Spinner } from '@cian/ui-kit';
import React from 'react';

import styles from './LoadableFallback.css';

export const LoadableFallback: React.FC = () => {
  return (
    <div className={styles['container']}>
      <Spinner fill="rgb(115, 122, 142)" />
    </div>
  );
};
